module.exports = require("./wae-CH.js");